export const INSPECT_SEAT = 'booking/INSPECT_SEAT';
export const ADD_TICKET = 'booking/ADD_TICKET';
export const REMOVE_TICKET = 'booking/REMOVE_TICKET';
export const FILL_TICKET_STORE = 'booking/FILL_TICKET_STORE';
export const TOGGLE_TICKET_STORE = 'booking/TOGGLE_TICKET_STORE';
export const ADD_TO_BASKET_PENDING = 'booking/ADD_TO_BASKET_PENDING';
export const ADD_TO_BASKET_SUCCESS = 'booking/ADD_TO_BASKET_SUCCESS';
export const ADD_TO_BASKET_FAILED = 'booking/ADD_TO_BASKET_FAILED';
export const BATCH_SELECT = 'booking/BATCH_SELECT';
export const SELECT_ITEM_FOR_EDITING = 'booking/SELECT_ITEM_FOR_EDITING';
export const DESELECT_ITEM_FOR_EDITING = 'booking/DESELECT_ITEM_FOR_EDITING';
export const TOGGLE_ITEM_SELECTION_FOR_EDITING = 'booking/TOGGLE_ITEM_SELECTION_FOR_EDITING';
export const CLEAR_SELECTION = 'booking/CLEAR_SELECTION';
export const SELECT_ALL = 'booking/SELECT_ALL';
export const ASSIGN_ITEMS_PENDING = 'booking/ASSIGN_ITEMS_PENDING';
export const ASSIGN_ITEMS_COMPLETE = 'booking/ASSIGN_ITEMS_COMPLETE';
export const ASSIGN_ITEMS_FAILED = 'booking/ASSIGN_ITEMS_FAILED';
export const MERGE_STATE = 'booking/MERGE_STATE';
export const SET_BOOKING_LAYER_VISIBILITY = 'booking/SET_BOOKING_LAYER_VISIBILITY';
export const SET_ADDITIONAL_PARAMS = 'booking/SET_ADDITIONAL_PARAMS';
export const SET_ITEMS = 'booking/SET_ITEMS';
export const SET_MARKETING_TITLE = 'booking/SET_MAPKETING_TITLE';
export const SET_EVENT_NAME = 'booking/SET_EVENT_NAME';
export const SET_EVENT_CODE = 'booking/SET_EVENT_CODE';
export const SET_PRODUCTS = 'booking/SET_PRODUCTS';
export const SET_MAP = 'booking/SET_MAP';



// WEBPACK FOOTER //
// ./src/vuex/modules/booking/mutation-types.js